<template>
  <div class="tags_content">
    <van-field
      v-model="currentValue"
      disabled
      :label="title"
      input-align = "right"
      @click.native="popupVisible = true"
      :error= "error"
      type="textarea"
      placeholder="请选择合同标签" 
      rows="1"
      autosize
    />
    
    <van-popup v-model="popupVisible" position="bottom" class="mint-popup-4 tags_box">
      <van-nav-bar
        title="合同标签"
        right-text="确认"
        @click-right="back"
      />
      <van-checkbox-group v-model="currentId">
        <van-checkbox
          v-for="(item, index) in voptions"
          :key="index"
          :name="item.value"
        >
          {{ item.label }}
        </van-checkbox>
      </van-checkbox-group>
      <van-cell-group v-show="currentId.includes('201')">
        <van-field 
          v-model="other" 
          placeholder="其他" 
          name="other"
        />
      </van-cell-group>
    </van-popup>
  </div>
</template>

<script>
  export default {
    name: "ax-tags",
    props: {
      value: [Array],
      title: [String,Number],
      voptions: [Array],
      error: [ Boolean ]
    },
    data() {
      return {
        currentValue: '',
        currentArr: [],
        currentId: this.value || [],
        other: '',
        popupVisible: false,
        options: this.voptions,
        showOther: false,
        optionsMap:new Map([['201','输出商标/品牌'],['202','输出版权'],['203','输出版权111'],['204','输出版权2222'],['205','输出版权2222'],['206','输出版权6333'],['212','其他']]),
      }
    },
    created(){
      // console.log(this.currentId);
    },
    methods: {
      back:function () {
        this.popupVisible = false;
      }
    },
    watch: {
      currentId: function (val, oldVal){
        this.$emit('input', this.currentId);
      },
      value :function(val,oldVal){
        let _this = this;
        if(val!==oldVal){
          this.currentId = this.value;
          _this.currentArr = [];
          this.value.forEach(element => {
            _this.currentArr.push(this.optionsMap.get(element))
          });
          this.currentValue = this.currentArr.join(',');
        }
      }
    },
  }
</script>

<style>
  .tags_content .van-checkbox{
    margin: 10px 0 0 20px;
  }
  .tags_content .van-checkbox-group{
    margin-bottom: 10px;
  }
</style>
